import { AxiosResponse } from "axios";
import { BASE_URL, httpClient } from "../config/develop-config";
import { PinedNewsEntity } from "../entities/NewsEntity";
import { ApplicationName } from "../definitions/applicationName";

const baseUrl = `${BASE_URL}/news`;
// const baseUrl = `http://localhost:3002`;

const getNewsList = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/news`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const getNewsById = async (newsId: string) => {
  return await httpClient
    .get(`${baseUrl}/news/get`, { params: { newsId } })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const createNews = async (data: FormData) => {
  return await httpClient
    .post(`${baseUrl}/news/create`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const updateNews = async (data: FormData) => {
  return await httpClient
    .post(`${baseUrl}/news/update`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const deleteNews = async (data: { newsId: string; updateBy: string }) => {
  return await httpClient
    .delete(`${baseUrl}/news`, { data })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const getPinedNewsList = async (params: { company: string; app?: ApplicationName }) => {
  return await httpClient
    .get(`${baseUrl}/pined`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const updatePinedNewsList = async (data: { newsList: PinedNewsEntity[]; createBy: string }) => {
  return await httpClient
    .post(`${baseUrl}/pined/update`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const getHighlightList = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/highlight`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const getHighlightById = async (highlightNewsId: string) => {
  return await httpClient
    .get(`${baseUrl}/highlight/get`, { params: { highlightNewsId } })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getShopHighlightById = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/highlight-news-shop/`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const createHighlight = async (data: FormData) => {
  return await httpClient
    .post(`${baseUrl}/highlight/create-without-flash-sale`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const updateHighlight = async (data: FormData) => {
  return await httpClient
    .post(`${baseUrl}/highlight/update-without-flash-sale`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const deleteHighlight = async (data: { highlightNewsId: string; updateBy: string }) => {
  return await httpClient
    .delete(`${baseUrl}/highlight`, { data })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const getNewsShop = async (params: {
  newsId: string;
  zone?: string;
  customerGroupName?: string;
  searchText?: string;
  page?: number;
  take?: number;
  sortingDirection?: "ASC" | "DESC";
  sortBy?: string;
}) => {
  return await httpClient
    .get(`${baseUrl}/news-shop`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const checkShopHighlight = async (data: object) => {
  return await httpClient
    .post(`${baseUrl}/highlight/check-highlight-shop`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const createHighlightFlashSale = async (data: FormData) => {
  return await httpClient
    .post(`${baseUrl}/highlight/create-with-flash-sale`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const convertImageFlashSale = async (fileImg: any) => {
  const formData = new FormData();
  formData.append("image", fileImg);
  return await httpClient
    .post(`${baseUrl}/highlight/upload-highlight-news-flash-sale-image`, formData)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

export {
  getNewsList,
  getNewsById,
  createNews,
  updateNews,
  deleteNews,
  getPinedNewsList,
  updatePinedNewsList,
  getHighlightList,
  getHighlightById,
  createHighlight,
  updateHighlight,
  deleteHighlight,
  getNewsShop,
  checkShopHighlight,
  createHighlightFlashSale,
  getShopHighlightById,
  convertImageFlashSale,
};
